import React from 'react';

const AtcVaciasChart = ({ vaciasCount = 0, total = 100, loading = false, year }) => {
  const radius = 45;
  const strokeWidth = 8;
  const dashLength = 0.5;
  const gapLength = 2;
  const circumference = 2 * Math.PI * radius;
  const dotRadius = 0.4;

  const totalSegments = Math.floor(circumference / (dashLength + gapLength));

  const porcentajeVacias = Math.min(100, (vaciasCount / total) * 100);
  
  const blueSegments = Math.round((porcentajeVacias / 100) * totalSegments);

  const buildCircle = () => {
    const elements = [];
    const angleStep = 360 / totalSegments;

    for (let i = 0; i < totalSegments; i++) {
      const isGreen = i < blueSegments;
      const color = isGreen ? '#76A140' : '#E0E0E0';

      elements.push(
        <circle
          key={`dash-${i}`}
          cx="50"
          cy="50"
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={`${dashLength} ${circumference}`}
          strokeDashoffset={-i * (dashLength + gapLength)}
          transform="rotate(-90 50 50)"
        />
      );

      const angle = i * angleStep - 90;
      const radian = (angle * Math.PI) / 180;
      const dotDistance = radius - 5;
      const x = 50 + dotDistance * Math.cos(radian);
      const y = 50 + dotDistance * Math.sin(radian);

      elements.push(
        <circle
          key={`dot-${i}`}
          cx={x}
          cy={y}
          r={dotRadius}
          fill={color}
        />
      );
    }

    return elements;
  };

  if (loading) {
    return (
      <div className="w-full h-[250px] flex items-center justify-center bg-white rounded-[10px] shadow-md">
        <div className="w-6 h-6 border-2 border-gray-300 rounded-full animate-spin border-t-transparent" />
        <p className="ml-3 text-gray-500">Cargando...</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center gap-6 w-full h-full p-4 bg-white rounded-[10px] shadow-lg">
      <h3 className="text-lg text-center text-blue font-itcbold">Número de ATC vacías</h3>
      <div className="relative">
        <svg width="180" height="180" viewBox="0 0 100 100">
          {buildCircle()}
          <text
            x="50"
            y="50"
            textAnchor="middle"
            dominantBaseline="middle"
            fontSize="16"
            className='font-itcbold'
            fill="#007696"
          >
            {vaciasCount}
          </text>
        </svg>
      </div>
    </div>
  );
};

export default AtcVaciasChart;